/**
 * Decided:
 *  - A user will be able to submit answers as many times as he wants.
 */

export const challengeStatus = {
  LOCKED: 'locked',
  UNLOCKED: 'unlocked',
  SOLVED: 'solved',
  FAILED: 'failed',
}

export const challengeActivityType = {
  CHALLENGE: 'Challenge',
  FINISH_LINE: 'Finish line',
  OTHER: 'Other'
}



// WEBPACK FOOTER //
// ./src/services/challengeStatus.enum.js